import mixpanel from "mixpanel-browser";
import config from "../../config";

mixpanel.init(config.mixpanel.projectToken, { debug: process.env.NODE_ENV !== "production" });

const HOMEPAGE = "Homepage";
const TEST_COVID_PAGE = "Test Covid Page";
const TEST_CARDIO_PAGE = "Test Cardio Page";
const userAgent = window.navigator.userAgent;
export const trackHomePage = (uid) => {
  const trackingOptions = {
      distinct_id: uid,
      userAgent,
  };
  mixpanel.track(HOMEPAGE, trackingOptions);
};
export const trackCovidTestPage = (uid) => {
  const trackingOptions = {
      distinct_id: uid,
      userAgent,
  };
  mixpanel.track(TEST_COVID_PAGE, trackingOptions);
};
export const trackCardioTestPage = (uid) => {
  const trackingOptions = {
      distinct_id: uid,
      userAgent,
  };
  mixpanel.track(TEST_CARDIO_PAGE, trackingOptions);
};
